import React, { useEffect, Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/toaster";
import Home from "./pages/Home";

const MenuPage = lazy(() => import("./pages/MenuPage"));
const MooncakePage = lazy(() => import("./pages/MooncakePage"));
const CakePage = lazy(() => import("./pages/CakePage"));
const ClassPage = lazy(() => import("./pages/ClassPage"));
const BlogList = lazy(() => import("./pages/BlogList"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const Faq = lazy(() => import("./pages/Faq"));
const Contact = lazy(() => import("./pages/Contact"));
const NotFound = lazy(() => import("./pages/NotFound"));

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function PageLoader() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center" data-testid="page-loader">
      <span className="h-8 w-8 animate-spin rounded-full border-2 border-[#148456] border-t-transparent" />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="flex min-h-screen flex-col">
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/eat-clean" element={<Suspense fallback={<PageLoader />}><MenuPage /></Suspense>} />
              <Route path="/thuc-don" element={<Suspense fallback={<PageLoader />}><MenuPage /></Suspense>} />
              <Route path="/banh-trung-thu" element={<Suspense fallback={<PageLoader />}><MooncakePage /></Suspense>} />
              <Route path="/banh-kem" element={<Suspense fallback={<PageLoader />}><CakePage /></Suspense>} />
              <Route path="/lop-hoc-lam-banh" element={<Suspense fallback={<PageLoader />}><ClassPage /></Suspense>} />
              <Route path="/danh-muc/kien-thuc" element={<Suspense fallback={<PageLoader />}><BlogList /></Suspense>} />
              <Route path="/hoi-dap" element={<Suspense fallback={<PageLoader />}><Faq /></Suspense>} />
              <Route path="/lien-he" element={<Suspense fallback={<PageLoader />}><Contact /></Suspense>} />
              <Route path="/:slug" element={<Suspense fallback={<PageLoader />}><BlogPost /></Suspense>} />
              <Route path="*" element={<Suspense fallback={<PageLoader />}><NotFound /></Suspense>} />
            </Routes>
          </main>
          <Footer />
        </div>
        <Toaster />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
